import { FC } from "react";

import { SelectComponentProps } from "./types";
import { Option } from "../types";
import { PrimaryPill } from "../../Pill/PrimaryPill";

const getValueLabel = (props: MultiValueProps) => {
  return (props.data as Option).label;
};

type MultiValueProps = SelectComponentProps["MultiValue"];

export const MultiValue: FC<MultiValueProps> = (props) => {
  if (props.selectProps.menuIsOpen || !props.isMulti) return null;

  const { translateOptions = true } = props.selectProps;

  return (
    <PrimaryPill
      variant="INACTIVE"
      {...(translateOptions ? {} : { "data-notranslate": "true" })}
    >
      {getValueLabel(props)}
    </PrimaryPill>
  );
};
